import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../types";

export const DefaultLine = ({ options }: ComponentLineProps) => (
  <DefaultFullPreview.PreviewEntry label="" {...options} />
);
